import * as http from 'utils/http';
import { put, call, takeLatest } from 'redux-saga/effects';
import { request, done, cancel } from './duck';
import config from 'config';

// @effect Action
const load$ = 'areas/load$';

// @effect Creators
export const loadAreas = () => ({
  type: load$,
});

// Workers
function* fetchAreas() {
  yield put(request());
  try {
    const URL = `${config.API_URL}areas/?page_size=0`;
    const areas = yield call(http.get, URL);
    yield put(done(areas));
  } catch (err) {
    yield put(cancel(err));
  }
}

function* load() {
  yield call(fetchAreas);
}

// Watchers
export function* watchAreas() {
  yield takeLatest(load$, load);
}
